import React from "react";

import { Spacer } from "components/base/Spacer";
import { FilterSectionFlexboxGrid, StyledItemAutoMargin, StyledItemFitWidth } from "components/base/FitContainers";

import GanNumbersActionList from "../GanNumbersActionList/GanNumbersActionList";
import NumbersActions from "../NumbersActions";
import { FooterActions, Header } from "../../styled";

const AllocatedNumbersSupplierContainer = ({
    isGanTrunks,
    isMobile,
    currentDisplay,
    selectedItems,
    selected,
    dataCount,
    service,
    ganNumbersExtraParams,
    hasSelected,
    hasGanBlocked,
    ganNumberSuccess,
    permissions,
    showReasonHandler,
    onOpenSetLimit,
    TableSection,
    tableSectionProps,
    isTransitTrunks,
    actions,
    footerActionsDisabled,
    footerActionsLoading,
    disabledActions,
    ModalsHost,
    modalHostProps,
}) => {
    return (
        <>
            {isGanTrunks && <Spacer />}

            {isGanTrunks && <FilterSectionFlexboxGrid controlable={!isMobile}>
                <StyledItemFitWidth controlable={!isMobile} isMobile={isMobile}>
                    {["numbers", "groups"].includes(currentDisplay)
                        ? <Header className="ml-2">{currentDisplay === "numbers" ? "GAN Numbers" : "GAN Groups"}</Header>
                        : <></>
                    }
                </StyledItemFitWidth>

                <StyledItemAutoMargin isMobile={isMobile}>
                    {!isMobile &&
                        <GanNumbersActionList
                            onSuccess={ganNumberSuccess}
                            currentDisplay={currentDisplay}
                            selectedItems={selectedItems}
                            selected={selected}
                            count={dataCount}
                            service={service}
                            extraParams={ganNumbersExtraParams}
                            currentGroupData={{}}
                            hasSelected={hasSelected}
                            hasBlocked={hasGanBlocked}
                            handleSuccess={ganNumberSuccess}
                            permissions={permissions}
                            showReasonHandler={showReasonHandler}
                            setShowLimit={onOpenSetLimit}
                        />
                    }
                </StyledItemAutoMargin>
            </FilterSectionFlexboxGrid>}

            <TableSection {...tableSectionProps} />

            {!isGanTrunks && (
                <FooterActions>
                    <NumbersActions
                        selected={selected}
                        actions={actions}
                        disabled={!hasSelected || footerActionsDisabled}
                        loading={footerActionsLoading}
                        disabledItemValues={disabledActions}
                    />
                </FooterActions>
            )}

            <ModalsHost {...modalHostProps} />
        </>
    );
};

export default AllocatedNumbersSupplierContainer;
